export const OSM_POI_INGESTION_HREF = "#/admin/food-access-map";

export function parseOsmPoiApiError(error) {
  if (!error) {
    return "OSM food POI request failed.";
  }
  if (typeof error === "string") {
    return error;
  }
  if (error.message) {
    return error.message;
  }
  return "OSM food POI request failed.";
}

export function getOsmPoiRunResultMessage(result) {
  if (!result) {
    return null;
  }

  const ingestion = result.ingestion || result;
  const inserted = ingestion.storesInserted ?? 0;
  const updated = ingestion.storesUpdated ?? 0;
  const mapped = ingestion.storesMapped ?? 0;
  const status = ingestion.status || (result.success ? "COMPLETED" : "ERROR");

  if (result.dryRun) {
    return `Dry run mapped ${mapped} OSM food POI store(s).`;
  }

  return `${status}: ${inserted} inserted, ${updated} updated (${mapped} mapped from ${ingestion.elementsFetched ?? 0} OSM elements).`;
}
